import React, { Component, createRef } from 'react';
import { URLImgFront } from '../../../config/URLDB';
import AOS from 'aos';
import 'aos/dist/aos.css';

class LottieLoader extends Component {
    constructor(props) {
        super(props);
        this.loaderRef = createRef();
        this.state = {
            fadeOut: false,
            showContent: false
        };
    }

    componentDidMount() {
        document.body.classList.add('loading');
        if (window.lottie && this.loaderRef.current) {
            this.anim = window.lottie.loadAnimation({
                container: this.loaderRef.current,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: `${URLImgFront}/assets/EstrategiasComerciales/loading.json`
            });
        }
        setTimeout(() => {
            this.setState({ fadeOut: true });

            setTimeout(() => {
                this.setState({ showContent: true });
                document.body.classList.remove('loading');
                AOS.refresh();
            }, 800); 
        }, 2500);
    }

    componentWillUnmount() {
        if (this.anim) {
            this.anim.destroy();
        }
    }

    render() {
        const { fadeOut, showContent } = this.state;

        return (
            <>
                {!showContent && (
                    <div className={`lottie-loader ${fadeOut ? 'fade-out' : ''}`}>
                        <div ref={this.loaderRef} style={{ width: 100, height: 100 }}></div>
                    </div>
                )}
                {showContent && (
                    <div className={`lottie-content ${showContent ? 'visible' : 'hidden'}`}>
                        {this.props.children}
                    </div>
                )}
                
            </>
        );
    }
}

export default LottieLoader;
